// eslint-disable-next-line
import React, { } from 'react';
import {
    Typography,
    Card,
    ListSubheader,
    Divider,
} from '@mui/material';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import * as PXBColors from '@brightlayer-ui/colors';
import { FormatDateInText } from '../enum/DateTimeFormat';
import { platformDetail } from '../../types/platform';

type Props = {
    platformInfo: platformDetail;
};

export const PlatformSlaDetails: React.FC<React.PropsWithChildren<React.PropsWithChildren<Props>>> = (props: Props) => {
    const { t } = useLanguageLocale();

    return (
        <>
            <Card style={{ flex: '1 1 0px', overflow: 'auto' }} id="platform-sla-details" data-testid="platform-sla-details-container">
                <ListSubheader
                    component="div"
                    data-testid="sla-details-header"
                    id="sla-details-header"
                    style={{
                        display: 'flex',
                        fontWeight: 600,
                        fontSize: 14,
                        alignItems: 'center',
                        overflow: 'auto',
                        whiteSpace: 'nowrap',
                        marginLeft: 10,
                        height: 60,
                    }}

                >

                    <Typography
                        variant="subtitle1"
                        style={{
                            alignItems: 'left',
                            color: PXBColors.blue[600],
                            width: '92.3%',
                            paddingLeft: '10',
                        }}
                        id="sla-details-title"
                        data-testid="sla-details-title"
                    >
                        {t('CUSTOMER_DETAILS.SLA_DETAILS_HEADER')}

                    </Typography>
                </ListSubheader>
                <Divider />
                <div style={{ paddingLeft: 24, paddingTop: 8, paddingBottom: 8 }}>
                    <Typography variant='h6'>{props.platformInfo.slaNumber}</Typography>
                    <Typography data-testid='expiryDateHelpertextPlatform' variant='body1'>{t('CUSTOMER_DETAILS.EXPIRES') + FormatDateInText(props.platformInfo.slaExpiryDate)}</Typography>
                </div>
            </Card >
        </>
    );
};
